"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSupportedLngs = void 0;
// default languages based on current dex v1
const DEFAULT_LANGUAGES = [
    {
        locale: "ar",
        localeString: "عربي",
    },
    {
        locale: "de",
        localeString: "Deutsch",
    },
    {
        locale: "en",
        localeString: "English",
    },
    {
        locale: "es",
        localeString: "Español",
    },
    {
        locale: "fr",
        localeString: "Français",
    },
    {
        locale: "it",
        localeString: "Italiano",
    },
    {
        locale: "ja",
        localeString: "日本語",
    },
    {
        locale: "nl",
        localeString: "Nederlands",
    },
    {
        locale: "pt",
        localeString: "Português",
    },
    {
        locale: "ru",
        localeString: "Русский",
    },
    {
        locale: "th",
        localeString: "ภาษาไทย",
    },
];
const getSupportedLngs = (supportedLngs) => {
    const langs = supportedLngs !== null && supportedLngs !== void 0 ? supportedLngs : DEFAULT_LANGUAGES;
    return langs.map((lang) => lang.locale);
};
exports.getSupportedLngs = getSupportedLngs;
//# sourceMappingURL=languages.js.map